module.exports = __webpack_public_path__ + "img/产品中心 条幅3.baf80c01.jpg";